exports.LANGUAGE = {
  en: 'English',
  ja: '日本語',
  ko: ' 한국어',
  'zh-cn': '',
  'zh-Hans': '',
  'zh-Hant': '繁体中文',
  'zh-tc': '',
  it: '',
  in: '',
  id: '',
  es: 'ESPAÑOL',
  pt: 'PORTUGUÊS',
  de: 'DEUTSCH',
  fr: 'FRANÇAIS',
  ru: 'РУССКИЙ',
  th: 'ภาษาไทย'
};
exports.LANGUAGE_NAME = {
  en: '英文',
  'zh-cn': '简体中文',
  'zh-Hans': '简体中文',
  'zh-Hant': '繁体中文',
  'zh-tc': '繁体中文',
  ja: '日语',
  ko: '韩语',
  th: '泰语',
  it: '意大利语',
  in: '印度尼西亚语',
  id: '印度尼西亚语',
  es: '西班牙',
  ru: '俄语',
  de: '德语',
  fr: '法语',
  pt: '葡萄牙语'
};
exports.XIGUA_LANGUAGE = {
  en: 'en',
  'zh-cn': 'zh-Hans',
  'zh-Hans': 'zh-Hans',
  'zh-tc': 'zh-Hant',
  ja: 'ja',
  ko: 'ko',
  th: 'th',
  it: 'it',
  id: 'in',
  es: 'es',
  ru: 'ru',
  de: 'de',
  fr: 'fr',
  'zh-Hant': 'zh-Hant',
  in: 'in',
  pt: 'pt'
};

exports.ZT_LANGUAGE = {
  en: 'en',
  'zh-cn': 'zh-Hans',
  'zh-Hans': 'zh-Hans',
  'zh-tc': 'cht',
  ja: 'jp',
  ko: 'kor',
  th: 'th',
  it: 'it',
  id: 'id',
  es: 'spa',
  ru: 'ru',
  de: 'de',
  fr: 'fra',
  'zh-Hant': 'cht',
  in: 'id',
  pt: 'pt'
};

/**
 *
 * zho（简体中文）
 * eng（英文）
 * zho-tw（台湾）
 * zho-hk（香港）
 * udm（维吾尔语）
 * jpn（日文）
 * ind（印尼）
 * kor（韩语）
 * rus（俄语）
 * ara（阿拉伯语）
 * spa（西班牙语）
 * pon（巴西葡语）
 * por（欧洲葡语）
 * fra（法语）
 * deu（德语）
 * @type {{de: string, 'zh-HANT': string, ru: string, ko: string, th: string, ja: string, en: string, it: string, id: string, fr: string, es: string}}
 */
exports.GEETEST_LANGUAGE = {
  en: 'eng',
  'zh-cn': 'zho',
  'zh-Hans': 'zho',
  'zh-tc': 'zho-hk',
  ja: 'jpn',
  ko: 'kor',
  th: 'eng',
  it: 'eng',
  id: 'ind',
  es: 'spa',
  ru: 'rus',
  de: 'deu',
  fr: 'fra',
  'zh-Hant': 'zho-hk',
  in: 'ind',
  pt: 'por'
};

exports.TDK = {
  en: {
    title: 'Mecha BREAK Official Site: Mashmak Survival Guide',
    keywords: 'Operation STORM,Mashmak,Mashmak Survival Guide,Mecha BREAK,Mecha BREAK Official Site,Mech Game,Sci-Fi Game,Shooter Game,Action Game',
    description:
      'Enter Mashmak solo or in a squad of three—search, clear, and extract from perilous hotspots. Engage entrenched enemies in Restricted Zones to secure tactical supplies, and evacuate with your loot and combat data before Corite Pulse Storms engulf the island. Access to Mashmak operations has now been authorized.'
  },
  ja: {
    title: '「Mecha BREAK」公式サイト — マシュマーク攻略ガイド',
    keywords: 'ストームレイド,マシュマーク,マシュマーク攻略ガイド,Mecha BREAK,Mecha BREAK公式サイト,メカゲーム,SFゲーム,シューティングゲーム,アクションゲーム',
    description:
      'ソロまたは3人チームで各危険区域で探索、戦闘、そして脱出。封鎖エリア各拠点の守備軍と交戦し、作戦物資を確保。そしてEICパルスストームが拡散する前に脱出を成功させ、戦術物資と作戦データを持ち帰ることを目指そう！'
  },
  ko: {
    title: '<Mecha BREAK> 공식 사이트 — 매시마크 공략집',
    keywords: '스톰 작전, 매시마크, 매시마크 공략집, Mecha BREAK, Mecha BREAK 공식 사이트, 메카 게임, SF 게임, 슈팅 게임, 액션 게임',
    description:
      '솔로 또는 멀티 스쿼드로 위험이 도사리는 핫스팟에 진입해 수색-교전-철수 작전을 수행하게 됩니다. 봉쇄 구역에 흩어진 주요 거점을 탐색하고 방어군과 교전하며 전술 물자와 전투 데이터를 확보하세요. 단, 코라이트 펄스 스톰이 확산되기 전에 안전지대로 탈출해야만 획득한 물자와 데이터를 온전히 회수할 수 있습니다. 현재 매시마크 군도 작전 권한이 공식적으로 활성화되었습니다.'
  },
  'zh-Hant': {
    title: '《Mecha BREAK》官網 — 瑪什馬克攻略站',
    keywords: '風暴行動,瑪什馬克,瑪什馬克攻略站,Mecha BREAK,Mecha BREAK官網,機甲遊戲,科幻遊戲,射擊遊戲,動作遊戲',
    description:
      '以單人或三人小隊模式進入各大危機四伏的熱點地區，開啟你的搜、打、撤征途。探索分布於封鎖區各處的重要據點並與守軍交戰，收集作戰物資，在EIC脈衝暴擴散前完成撤離，保障戰術物資與作戰數據安全返回。目前，已為您開放瑪什馬克群島的探索作戰權限。'
  },
  es: {
    title: 'Sitio web oficial de Mecha BREAK: Guía de Mashmak',
    keywords:
      'Operación STORM, Mashmak, Guía de Mashmak, Mecha BREAK, Sitio web oficial de Mecha BREAK, Juego de mechas, Juego de ciencia ficción, Juego de disparos, Juego de acción',
    description:
      'Adéntrate en Mashmak en solitario o en un escuadrón de tres: busca, despeja y extrae de las zonas de alto riesgo. Enfréntate a los enemigos atrincherados en las Zonas Restringidas para asegurar suministros tácticos y evacua con tu botín y datos de combate antes de que las Tormentas de Pulso de Corite azoten la isla. El acceso a las operaciones de Mashmak ya está autorizado.'
  },
  pt: {
    title: 'Site Oficial de Mecha BREAK: Guia de Sobrevivência em Mashmak',
    keywords:
      'Operation STORM, Mashmak, Guia de Sobrevivência em Mashmak, Mecha BREAK, Site Oficial de Mecha BREAK, Jogo de Mechas, Jogo de Ficção Científica, Jogo de Tiro, Jogo de Ação',
    description:
      'Entre em Mashmak sozinho ou em uma equipe de três — busque, elimine e extraia recursos de áreas perigosas. Enfrente inimigos entrincheirados nas Zonas Restritas para garantir suprimentos táticos e evacue com seus itens e dados de combate antes que as Tempestades de Pulso Corite engulam a ilha. O acesso às operações de Mashmak está agora autorizado.'
  },
  de: {
    title: 'Offizielle Mecha-BREAK-Website: Mashmak-Überlebensleitfaden',
    keywords:
      'Operation STURM, Mashmak, Mashmak-Überlebensleitfaden, Mecha BREAK, Offizielle Mecha-BREAK-Website, Mech-Game, Sci-Fi-Game, Shooter-Game, Action-Game',
    description:
      'Betritt Mashmak allein oder im Dreiertrupp – durchsuchen, säubern und extrahieren gefährlicher Hotspots.Stell dich in den Sperrzonen gut verschanzten Gegnern, sichere taktische Vorräte und evakuiere mit Beute und Kampfdaten, bevor die Corite-Pulsstürme die Insel verschlingen.Der Zugriff auf die Mashmak-Operationen ist nun freigegeben.'
  },
  fr: {
    title: 'Site officiel de Mecha BREAK : Guide de Mashmak',
    keywords:
      // eslint-disable-next-line quotes
      "Opération STORM, Mashmak, Guide de Mashmak, Mecha BREAK, Site officiel de Mecha BREAK, Jeu de mechas, Jeu de science-fiction, Jeu de tir, Jeu d'action",
    description:
      // eslint-disable-next-line quotes
      "Rendez-vous à Mashmak en solo ou en escouade de trois pour fouiller et évacuer diverses zones à haut risque tout en détruisant les ennemis. Affrontez des adversaires retranchés dans les zones restreintes pour obtenir des ressources tactiques et partez avec le butin et les données de combat avant que les orages pulsatifs de corite n'engloutissent l'île. L'accès à l'archipel de Mashmak pour les opérations est désormais autorisé."
  },
  ru: {
    title: 'Официальный сайт Mecha BREAK: руководства по выживанию на Мэшмаке',
    keywords: 'ШТОРМ,Мэшмак,Руководство по выживанию на Мэшиаке,Mecha BREAK,Официальный сайт Mecha BREAK,Mech Game, Научно-фантастические игры,Шутер,Экшен',
    description:
      'Направляйтесь в одиночку или в составе отряда до 3 игроков на Мэшмак — здесь вы сможете искать предметы, уничтожать противников и эвакуироваться из опасных зон. Вступайте в бой с укрепившимися врагами в Запретных зонах, чтобы собрать тактические припасы и эвакуироваться со своей добычей и боевыми данными до того, как коритские импульсные штормы полностью поглотят остров. Доступ к операциям на Мэшмаке открыт для всех пилотов.'
  },
  th: {
    title: 'เว็บไซต์ Mecha BREAK ทางการ: คู่มือเอาตัวรอดใน Mashmak',
    keywords: 'ปฏิบัติการ STORM, Mashmak, คู่มือเอาตัวรอดใน Mashmak, Mecha BREAK, เว็บไซต์ Mecha BREAK , เกมหุ่นยนต์, เกมไซไฟ, เกมชูตติ้ง, เกมแอคชั่น',
    description:
      'เข้าสู่ Mashmak คนเดียวหรือจับทีม 3 คน ทำการค้นหา, เคลียร์พื้นที่ และอพยพจากพื้นที่ความเสี่ยงสูง ทำการต่อสู้กับศัตรูที่ยึดครองเขตหวงห้ามเพื่อรับเสบียงยุทธวิธี ทำการหลบหนีพร้อมของที่ปล้นมาและข้อมูลการต่อสู้ก่อนที่พายุพัลซ์ Corite จะกลืนกินทั้งเกาะ ตอนนี้คุณได้รับสิทธิ์ให้เข้าถึงปฏิบัติการ Mashmak แล้ว'
  }
};
// 长链： //mechabreak.seasungames.com/p/m/2024/12/19/dlc/ 短链：//mechabreak.seasungames.com/m/
const pcTest = '//test-zt.seasungames.com/mechabreak.seasungames.com/zt/m/msmk/';
const pcMaster = '//mechabreak.seasungames.com/zt/m/msmk/';
exports.PC_ADDRESS = {
  en: {
    testUrl: pcTest + 'en/',
    masterUrl: pcMaster + 'en/index.html#/'
  },
  ja: {
    testUrl: pcTest + 'ja/',
    masterUrl: pcMaster + 'ja/index.html#/'
  },
  ko: {
    testUrl: pcTest + 'ko/',
    masterUrl: pcMaster + 'ko/index.html#/'
  },
  'zh-Hant': {
    testUrl: pcTest + 'zh-Hant/',
    masterUrl: pcMaster + 'zh-Hant/index.html#/'
  },
  es: {
    testUrl: pcTest + 'es/',
    masterUrl: pcMaster + 'es/index.html#/'
  },
  pt: {
    testUrl: pcTest + 'pt/',
    masterUrl: pcMaster + 'pt/index.html#/'
  },
  de: {
    testUrl: pcTest + 'de/',
    masterUrl: pcMaster + 'de/index.html#/'
  },
  fr: {
    testUrl: pcTest + 'fr/',
    masterUrl: pcMaster + 'fr/index.html#/'
  },
  ru: {
    testUrl: pcTest + 'ru/',
    masterUrl: pcMaster + 'ru/index.html#/'
  },
  th: {
    testUrl: pcTest + 'th/',
    masterUrl: pcMaster + 'th/index.html#/'
  }
};

exports.PROTOCOL = {
  en: {
    appointment: '//www.mechabreak.com/show-1034-38-1.html',
    cookie: '//www.mechabreak.com/show-1034-35-1.html',
    privacy: '//mechabreak.seasungames.com/show-1034-211-1.html',
    service: '//mechabreak.seasungames.com/show-1034-561-1.html'
  },
  ja: {
    appointment: '//www.mechabreak.com/show-1031-41-1.html',
    cookie: '//www.mechabreak.com/show-1031-36-1.html',
    privacy: '//mechabreak.seasungames.com/show-1033-209-1.html',
    service: '//mechabreak.seasungames.com/show-1033-210-1.html'
  },
  ko: {
    appointment: '//www.mechabreak.com/show-1031-40-1.html',
    cookie: '//www.mechabreak.com/show-1031-37-1.html',
    privacy: '//mechabreak.seasungames.com/show-1032-40-1.html',
    service: '//mechabreak.seasungames.com/show-1032-208-1.html'
  },
  'zh-Hant': {
    appointment: '//www.mechabreak.com/show-1031-39-1.html',
    cookie: '//www.mechabreak.com/show-1031-34-1.html',
    privacy: '//mechabreak.seasungames.com/show-1031-205-1.html',
    service: '//mechabreak.seasungames.com/show-1031-206-1.html'
  },
  es: {
    appointment: '//www.mechabreak.com/show-1094-146-1.html',
    cookie: '//www.mechabreak.com/show-1094-147-1.html',
    privacy: '//mechabreak.seasungames.com/show-1094-148-1.html',
    service: '//mechabreak.seasungames.com/show-1094-149-1.html'
  },
  pt: {
    appointment: '//www.mechabreak.com/show-1095-153-1.html',
    cookie: '//www.mechabreak.com/show-1095-152-1.html',
    privacy: '//mechabreak.seasungames.com/show-1095-151-1.html',
    service: '//mechabreak.seasungames.com/show-1095-150-1.html'
  },
  de: {
    appointment: '//www.mechabreak.com/show-1096-157-1.html',
    cookie: '//www.mechabreak.com/show-1096-156-1.html',
    privacy: '//mechabreak.seasungames.com/show-1096-155-1.html',
    service: 'https://mechabreak.seasungames.com/show-1096-154-1.html'
  },
  fr: {
    appointment: '//www.mechabreak.com/show-1097-161-1.html',
    cookie: '//www.mechabreak.com/show-1097-160-1.html',
    privacy: '//mechabreak.seasungames.com/show-1097-159-1.html',
    service: '//mechabreak.seasungames.com/show-1097-158-1.html'
  },
  ru: {
    appointment: '//www.mechabreak.com/show-1098-165-1.html',
    cookie: '//www.mechabreak.com/show-1098-164-1.html',
    privacy: '//mechabreak.seasungames.com/show-1098-163-1.html',
    service: '//mechabreak.seasungames.com/show-1098-162-1.html'
  },
  th: {
    appointment: '//mechabreak.seasungames.com/show-1238-242-1.html',
    cookie: '//mechabreak.seasungames.com/p/zt/2025/06/07/article-template/?contentId=m_mb_1034_324&lang=th#/',
    privacy: '//mechabreak.seasungames.com/show-1238-244-1.html ',
    service: '//mechabreak.seasungames.com/show-1238-242-1.html'
  }
};
/**
 * message的cms id
 * @type {{de: number, 'zh-Hant': number, ru: number, pt: number, th: number, ja: number, kr: number, en: number, fr: number, es: number}}
 */
exports.MESSAGE_CMS_ID = {
  en: 1223,
  de: 1224,
  es: 1225,
  fr: 1226,
  ja: 1227,
  ko: 1228,
  pt: 1229,
  ru: 1230,
  'zh-Hant': 1231,
  th: 1232
};
